import { Injectable } from "@angular/core";

/**
 * Handles the retrievable of browser details
 *
 * sources:
 *     https://github.com/bestiejs/platform.js
 *     http://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
 */
@Injectable()
export class TechCheckService {
    imageRoot = "assets/images/student/techCheck/";
    jscd: any;

    constructor() {
        this.setup();
    }

    /**
     * @method getDeviceInfo
     * @description returns the complete information about the device
     * @returns {any}
     */
    getDeviceInfo() {
        return this.jscd;
    }

    /**
     * @method getTechInfo
     * @description Retrieves basic tech information
     * @returns {{os: {name; image}; browser: {name; image: string}; screenResolution: {name: Screen; image: string}}}
     */
    getTechInfo() {
        let webcam = {
            name: "No Cam Detected"
        };
        // Set webcam name to iSight if os.name contains iOS
        const iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
            ? true
            : false;
        if (iOS === true) {
            webcam = {
                name: "iOS iSight"
            };
        }

        return {
            os: {
                name: this.jscd.os + " " + this.jscd.osVersion,
                image: this.imageRoot + this.jscd.os.toLowerCase() + ".png"
            },

            browser: {
                name: this.jscd.browser,
                image: this.imageRoot + this.jscd.browser.toLowerCase() + ".png"
            },

            screenResolution: {
                name: this.jscd.screen,
                image: this.imageRoot + this.jscd.screenSizeImg + ".png"
            },
            flash: {
                name: this.jscd.flashVersion,
                image: this.jscd.flashVersionImg
            },
            webcam: {
                name: webcam.name
            }
        };
    }

    /**
     * @method getFlashVersion
     * @description retrieves the flash version in x.x.x format
     * @returns {any}
     */
    getFlashVersion() {
        const version = (<any>window).swfObject.ua.pv.toString();
        return version;
    }

    /**
     * @method setup
     * @description creates the variable that contains all the information about the client browser/ device
     */
    setup() {
        const unknown = "";
        let width, height, screenSizeImg;

        // screen
        let screenSize = "";
        if (screen.width) {
            width = screen.width ? screen.width : "";
            height = screen.height ? screen.height : "";
            screenSize += "" + width + " x " + height;
            const intWidth = Number(width);
            if (intWidth < 768) {
                screenSizeImg = "resolutionNo";
            } else {
                screenSizeImg = "resolution";
            }
        }

        // browser
        const nVer = navigator.appVersion;
        const nAgt = navigator.userAgent;
        let browser = navigator.appName;
        let version = "" + parseFloat(navigator.appVersion);
        let majorVersion = parseInt(navigator.appVersion, 10);
        let nameOffset, verOffset, ix;

        if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
            // Opera
            browser = "Opera";
            version = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf("Version")) !== -1) {
                version = nAgt.substring(verOffset + 8);
            }
        } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
            // MSIE
            browser = "IE";
            version = nAgt.substring(verOffset + 5);
        } else if ((verOffset = nAgt.indexOf("Trident")) !== -1) {
            // MSIE v11+
            browser = "IE";
            version = nAgt.substring(verOffset + 7);
        } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
            // Chrome
            browser = "Chrome";
            version = nAgt.substring(verOffset + 7);
        } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
            // Safari
            browser = "Safari";
            version = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf("Version")) !== -1) {
                version = nAgt.substring(verOffset + 8);
            }
        } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
            // Firefox
            browser = "Firefox";
            version = nAgt.substring(verOffset + 8);
        } else if (
            (nameOffset = nAgt.lastIndexOf(" ") + 1) <
            (verOffset = nAgt.lastIndexOf("/"))
        ) {
            // Other browsers
            browser = nAgt.substring(nameOffset, verOffset);
            version = nAgt.substring(verOffset + 1);
            if (browser.toLowerCase() === browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        // trim the version string
        if ((ix = version.indexOf(";")) !== -1) {
            version = version.substring(0, ix);
        }
        if ((ix = version.indexOf(" ")) !== -1) {
            version = version.substring(0, ix);
        }

        majorVersion = parseInt("" + version, 10);
        if (isNaN(majorVersion)) {
            version = "" + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        // mobile version
        const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // cookie
        let cookieEnabled = navigator.cookieEnabled ? true : false;

        if (typeof navigator.cookieEnabled === "undefined" && !cookieEnabled) {
            document.cookie = "testcookie";
            cookieEnabled =
                document.cookie.indexOf("testcookie") !== -1 ? true : false;
        }

        // system
        let os = unknown;
        const clientStrings = [
            { s: "Windows 3.11", r: /Win16/ },
            { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
            { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
            { s: "Windows 98", r: /(Windows 98|Win98)/ },
            { s: "Windows CE", r: /Windows CE/ },
            { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
            { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
            { s: "Windows Server 2003", r: /Windows NT 5.2/ },
            { s: "Windows Vista", r: /Windows NT 6.0/ },
            { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
            { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
            { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
            { s: "Windows 8 Phone", r: /Windows Phone/ },
            {
                s: "Windows NT 4.0",
                r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
            },
            { s: "Windows ME", r: /Windows ME/ },
            { s: "Android", r: /Android/ },
            { s: "Open BSD", r: /OpenBSD/ },
            { s: "Sun OS", r: /SunOS/ },
            { s: "Linux", r: /(Linux|X11)/ },
            { s: "iOS", r: /(iPhone OS|iPad|iPod)/ },
            { s: "Mac OS X", r: /Mac OS X/ },
            { s: "Mac OS", r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
            { s: "QNX", r: /QNX/ },
            { s: "UNIX", r: /UNIX/ },
            { s: "BeOS", r: /BeOS/ },
            { s: "OS/2", r: /OS\/2/ },
            {
                s: "Search Bot",
                r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
            }
        ];
        for (let cs of clientStrings) {
            if (cs.r.test(nAgt)) {
                os = cs.s;
                break;
            }
        }

        let osVersion: any = unknown;

        if (/Windows/.test(os)) {
            const windowsRegExpArr = /Windows (.*)/.exec(os)
            if(windowsRegExpArr){
                osVersion = windowsRegExpArr[1];
            }
            os = "Windows";
        }

        switch (os) {
            case "Mac OS X":
                const macRegExpArr = /Mac OS X ([\.\_\d]+)/.exec(nAgt)
                if(macRegExpArr){
                    osVersion = macRegExpArr[1];
                }
                break;

            case "Android":
                const androidRegExpArr = /Android ([\.\_\d]+)/.exec(nAgt)
                if(androidRegExpArr){
                    osVersion = androidRegExpArr[1];
                }
                break;

            case "iPhone OS":
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                osVersion =
                    osVersion[1] + "." + osVersion[2] + "." + osVersion[3]
                        ? osVersion[3]
                        : 0;
                break;
        }

        const playerVersion = this.getFlashVersion();
        let flashPlayer = {
            name: null,
            image: ""
        };

        if (playerVersion === "0,0,0") {
            flashPlayer = {
                name: playerVersion,
                image: this.imageRoot + "flashNo.png"
            };
        } else {
            flashPlayer = {
                name: playerVersion,
                image: this.imageRoot + "flash.png"
            };
        }

        this.jscd = {
            screen: screenSize,
            screenSizeImg: screenSizeImg,
            browser: browser,
            browserVersion: version,
            mobile: mobile,
            os: os,
            osVersion: osVersion,
            cookies: cookieEnabled,
            flashVersion: flashPlayer.name,
            flashVersionImg: flashPlayer.image,
            isIos: !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
            isIPad: !!navigator.userAgent.match(/(iPad)/g),
            isIPhone: !!navigator.userAgent.match(/(iPhone)/g),
            isAndroid: !!navigator.userAgent.match(/(Android)/g)
        };
    }
}
